module.exports = __webpack_public_path__ + "img/87569-civitronic.8f79bb9a.png";